import { fetchActivityLogs } from '@/api/activity-logs.api';
export default {
    namespaced: true,

    state: {
        activityLogs: []
    },

    mutations: {
        setActivityLogs(state, logs) {
            state.activityLogs = logs;
        }
    },

    actions: {
        async fetchActivityLogs({ commit }, requestId) {
            const { success, logs, error } = await fetchActivityLogs(requestId);

            if (success) {
                commit('setActivityLogs', logs);

                return { success: true, logs };
            }

            return { success: false, error };
        }
    }
}